/* 
 *
 * ES6 ----------
 *
 */

import {isIE, browser, getTopLeftOfElement, isTouch} from './helpers';
import {Config, Events} from './models';

import Twitch from './views/twitch';


window.trace = function(str){
	console.log(str);
};

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

class App {

	constructor() {
		trace(' ----- APP is inited ---- ');
		this.times = 0;

		this.mouseDown = false;
		this.canvasA = new Twitch({});		
		this.canvases = [this.canvasA];
		
		window.addEventListener(Events.window.resize, this.resize.bind(this));

		this.animate = true;
		this.drawCanvas();
	}

	drawCanvas() {
		if( !this.animate ){
			return false;
		}

		// if( this.times > 3000 ){
		// 	this.animate = false;
		// }else{
		// 	this.times++;
		// }
		
		for( var c = 0 ; c < this.canvases.length; c++){
			this.canvases[c].animationFrame();
		}

		window.requestAnimationFrame( this.drawCanvas.bind(this) );
	}

	resize(e) {

		var obj = {
			ww : window.innerWidth,
			wh : window.innerHeight
		};

		for( var c = 0 ; c < this.canvases.length; c++){
			this.canvases[c].draw(obj);
		}

	}
}


window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.oRequestAnimationFrame;
window[Config.appNameSpace + 'App'] = new App();





/** WEBPACK FOOTER **
 ** ./src/js/app.es6.js
 **/